/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFamilyGameDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFamilyGameDay,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Have a Game Day Together!",
    "Family Game Day Awaits!",
    "Fun and Games for Everyone!",
  ],
  title: "Family Game Day",
  description: "Organize a fun family game day.",
  longDescription:
    "Gather your family for an exciting game day! Choose a date, decide on games to play, and plan snacks!",
  emoji: "🎲",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Family Game Day",
          emoji: "🎲",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the family game day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on games to play?",
            description: "What games should we focus on during the day?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What games should we consider?",
                emoji: "♟",
                completeAction: {
                  question: "Decide on snacks to have?",
                  description:
                    "What snacks should we prepare for the game day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍕",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Play Together!",
    outroDescription: "Your family game day plans are set! Enjoy the fun!",
  },
};
